import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectSession } from '@client/model/selectors';
import { analytics } from '@client/analytics';
import { SessionType } from '@shared';

export function AppOpenTracker() {
  const session = useSelector(selectSession);
  const hasTracked = useRef(false);

  useEffect(() => {
    // Only track once per page load, and wait until session is loaded
    if (hasTracked.current) return;
    if (session.isLoading) return;
    if (session.sessionType === SessionType.unknown) return;

    hasTracked.current = true;

    const isFirstOpen = !sessionStorage.getItem('app_opened');
    if (isFirstOpen) {
      sessionStorage.setItem('app_opened', 'true');
    }

    analytics.appOpen({
      entryPoint: document.referrer ? 'referral' : 'direct',
      isFirstOpen,
    });
  }, [session.isLoading, session.sessionType]);

  return null;
}
